import LogPage from "./LogPage";

export default LogPage;
